import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { api, customerapi } from "../../Appjs/api";
import { secureBaseQuery } from "./secureBaseQuery";
import {dynamicBaseQuery} from "./dynamicBaseQuery.js";


// Define API service
export const createDbapi = createApi({
  reducerPath: "CreateDB",
  baseQuery: fetchBaseQuery({
    baseUrl: api,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  //  baseQuery: dynamicBaseQuery,
  tagTypes: ["CreateDB"],
  endpoints: (builder) => ({
    submitConnections: builder.mutation({
      // data fields submitting api
      query: (data) => ({
        url: `${customerapi}/report/add-fields-to-table`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    getConnection: builder.query({
      query: () => ({
        url: `${customerapi}/report/get-table-schema`,
        method: "GET",
      }),
    }),
    postUploadData: builder.mutation({
      query: (FormData) => ({
        url: `${customerapi}/report/upload-excel-data`,
        method: "POST",
        body: FormData,
      }),
    }),
    getDbFields: builder.query({
      query: () => ({
        url: `${customerapi}/report/get-column-names`,
        method: "GET",
      }),
    }),
    getDownloadColumnNames: builder.mutation({
      query: (fileType = "csv") => ({
        url: `${customerapi}/report/download-column-names?fileType=${fileType}`,
        method: "GET",
        responseHandler: async (response) => {
          const blob = await response.blob();
          return {
            fileName: `column_names.${fileType === "excel" ? "xlsx" : "csv"}`,
            blob,
          };
        },
      }),
    }),
    submitViewDBFilters: builder.mutation({
      query: (data) => ({
        url: `${customerapi}/report/search-data`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    getdbfildsFilter: builder.query({
      query: () => ({
        url: `${customerapi}/report/get-table-schema`,
        method: "GET",
      }),
    }),
   postuploadsize: builder.mutation({
      query: (data) => ({
        url: `/report/check-upload-quota`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    getsearchdatalist: builder.query({
      query: () => ({
        url: `${customerapi}/report/get-search-data-list`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    deleteSearchData: builder.mutation({
      query: (customer_requestid) => ({
        url: `${customerapi}/report/delete-search-data/${customer_requestid}`,
        method: "DELETE",
      }),
    }),
    uploaddataquta: builder.query({
      query: () => ({
        url: `${customerapi}/report/storage-usage`,
        method: "GET",
      }),
    }),
    getcounts:builder.mutation({
      query: (Payload) => ({
        url: `${customerapi}/report/search-data-count`,
        body: Payload,
        method: "POST",
      }),
    }),
    UploadedDataCounts: builder.query({
      query: () => ({
        url: `${customerapi}/report/get-uploaded-record-count`,
        method: "GET",
      }),
    }),
    getusagehistorybyid:builder.query({
      query: (customer_requestid) => ({
        url: `${customerapi}/report/get-search-history/${customer_requestid}`,
        method: "GET",
    })
  }),
  geteventList:builder.query({
    query: () => ({
      url: `${customerapi}/event/get-events`,
      method: "GET",
    })
  }),
  createEvent:builder.mutation({
    query: (data) => ({
      url: `${customerapi}/event/create-filter-event`,
      method: "POST",
      body: data,
      headers: {
        "Content-Type": "application/json",
      },
    }),
  }),
  createEventFlow:builder.mutation({
    query: (data) => ({
      url: `${customerapi}/event/create-event`,
      method: "POST",
      body: data,
      headers: {
        "Content-Type": "application/json",
      },
    }),
  }),
  getsuggetionlist:builder.query({
    query: (fieldName) => ({
      url: `${customerapi}/report/autocomplete-field-values?fieldName=${fieldName}&limit=20`,
      method: "GET",
    })
  }),
  updatesearchdatalist:builder.mutation({
    query: (data) => ({
      url: `${customerapi}/report/update-search-data`,
      method: "PUT",
      body: data,
      headers: {
        "Content-Type": "application/json",
      },
    }),
  }),
  cancelSearchData:builder.mutation({
    query: (requestid) => ({
      url: `${customerapi}/report/cancel-data/${requestid}`,
      method: "POST",
    })
  }),
     getprefilledvalue: builder.query({
    query:(event_id)=>({
      url:`/event/get-event/${event_id}`,
      method:"GET",
    })
  }),
  setactiveinativeevent:builder.mutation({
    query: (data) => ({
      url: `/event/toggle-repeat-event-status/${data.event_id}`,
      method: "PATCH",
      body: data,
      headers: {
        "Content-Type": "application/json",
      },
    }),
  }),
})
});

export const {
  useSubmitConnectionsMutation,
  useGetConnectionQuery,
  usePostUploadDataMutation,
  useGetDbFieldsQuery,
  useGetdbfildsFilterQuery,
  useGetDownloadColumnNamesMutation,
  useSubmitViewDBFiltersMutation,
  usePostuploadsizeMutation,
  useGetsearchdatalistQuery,
  useDeleteSearchDataMutation,
  useUploaddataqutaQuery,
  useGetcountsMutation,
  useUploadedDataCountsQuery,
  useGetusagehistorybyidQuery,
  useGeteventListQuery,
  useCreateEventMutation,
  useCreateEventFlowMutation,
  useGetsuggetionlistQuery,
  useLazyGetsuggetionlistQuery,
  useUpdatesearchdatalistMutation,
  useCancelSearchDataMutation,
  useGetprefilledvalueQuery,
  useSetactiveinativeeventMutation,
} = createDbapi;
